import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=a1e0dd7e&scoped=true&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=a1e0dd7e&lang=scss&scoped=true&"
import style1 from "./Bookmarks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e0dd7e",
  null
  
)

export default component.exports